import { createElement, ReactNode, ComponentType } from 'react';
import { Colorway } from '@uds/theme-utils';

import Heading from './Heading';
import Paragraph from './Paragraph';
import ListItem from './ListItem';
import Link from './Link';
import ThematicBreak from './ThematicBreak';

interface OuterProps {
  colorway?: Colorway;
  children?: ReactNode;
  href?: string;
  level?: number;
}

const createRenderer = (Element: ComponentType<any>, ownerProps: OuterProps) => {
  return createElement(Element, ownerProps);
};

export default ({ colorway }: OuterProps) => ({
  heading: (props: OuterProps) =>
    createRenderer(Heading, {
      colorway,
      ...props,
    }),
  paragraph: (props: OuterProps) =>
    createRenderer(Paragraph, {
      colorway,
      ...props,
    }),
  listItem: (props: OuterProps) =>
    createRenderer(ListItem, {
      colorway,
      ...props,
    }),
  thematicBreak: (props: OuterProps) =>
    createRenderer(ThematicBreak, {
      colorway,
      ...props,
    }),
  link: (props: OuterProps) =>
    createRenderer(Link, {
      colorway,
      ...props,
    }),
});
